/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { filesteamDistIdGet } from '../fn/file-steam/filesteam-dist-id-get';
import { FilesteamDistIdGet$Params } from '../fn/file-steam/filesteam-dist-id-get';
import { filesteamGet } from '../fn/file-steam/filesteam-get';
import { FilesteamGet$Params } from '../fn/file-steam/filesteam-get';

@Injectable({ providedIn: 'root' })
export class FileSteamService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `filesteamDistIdGet()` */
  static readonly FilesteamDistIdGetPath = '/filesteam/dist/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `filesteamDistIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  filesteamDistIdGet$Response(params: FilesteamDistIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return filesteamDistIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `filesteamDistIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  filesteamDistIdGet(params: FilesteamDistIdGet$Params, context?: HttpContext): Observable<void> {
    return this.filesteamDistIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `filesteamGet()` */
  static readonly FilesteamGetPath = '/filesteam';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `filesteamGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  filesteamGet$Response(params?: FilesteamGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return filesteamGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `filesteamGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  filesteamGet(params?: FilesteamGet$Params, context?: HttpContext): Observable<void> {
    return this.filesteamGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
